<template>
  <div class="columns">
    <div class="column is-6">
      <form enctype="multipart/form-data" ref="form">
        <div class="columns">
          <div class="column">
            <b-field label="Logo">
              <b-upload v-model="logo" accept="image/*">
                <b-button icon-left="upload" tag="a">
                  <span>{{ logo ? logo.name : "Choose File" }}</span>
                </b-button>
              </b-upload>
            </b-field>

            <div
              v-if="firmAssociation.firm.logo"
              class="image-logo"
              style="max-width: 400px"
            >
              <figure class="image is-fullwidth">
                <img
                  :src="firmAssociation.firm.logo.path"
                  ref="imageLogo"
                  class="logo"
                />
              </figure>
            </div>
          </div>
        </div>

        <b-field label="Code">
          <b-input v-model="form.councilId"></b-input>
        </b-field>

        <br />

        <base-tag-input
          attach-mode
          :value="reverseAssociation ? reverseAssociation.tags : []"
          model-type="firm_association"
          :model-id="reverseAssociation ? reverseAssociation.id : null"
          :type="!reverseAssociation ? 'is-danger' : ''"
          :message="!reverseAssociation ? 'No reverse association' : ''"
          :disabled="!reverseAssociation"
        />

        <br />

        <b-field label="Your Rating" v-if="firm" class="rating-div">
          <star-rating
            class="mb-1"
            :increment="0.1"
            :rating="doneRate.rating"
            :star-size="20"
            :show-rating="false"
            read-only
            v-if="doneRate"
          />

          <star-rating
            class="mb-1"
            :increment="0.1"
            :rating="0"
            :star-size="20"
            :show-rating="false"
            read-only
            v-else
          />

          <template v-if="canRate && !doneRate">
            <button
              class="button rate-button"
              type="button"
              @click="modal.active = true"
            >
              Rate
            </button>

            <b-modal :active.sync="modal.active" has-modal-card>
              <rating-modal :rate="rate" />
            </b-modal>
          </template>

          <p v-if="firm.ratings.length && doneRate">
            Notes: {{ doneRate.notes }}
          </p>
        </b-field>

        <br />

        <button
          type="button"
          class="button is-info is-fullwidth"
          @click="saveLogo"
        >
          Save
        </button>
      </form>
    </div>

    <div class="column is-6">
      <portal-form :portal.sync="portal" :model="firm" />
    </div>
  </div>
</template>

<script>
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import StarRating from "vue-star-rating";
import RatingModal from "@/components/Rating/RatingModal";
import PortalForm from "@/components/pages/Portals/partials/organizationPortalForm";
import BaseTagInput from "@/components/partials/BaseTagInput";

export default {
  components: {
    StarRating,
    RatingModal,
    PortalForm,
    BaseTagInput,
  },
  props: ["firm", "firmAssociation"],
  data: () => ({
    logo: null,
    currentTags: null,
    activeTags: {},
    reverseAssociation: null, // Reverse of firmAssociation (firm_firm)
    form: {
      councilId: "",
      tags: [],
    },
    modal: {
      active: false,
    },
    portal: null,
  }),
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    doneRate() {
      return this.firm.ratings.find((element) => {
        return element.createdBy == this.user.id;
      });
    },
    canRate() {
      return this.$store.getters["Auth/hasFirmPermission"]("can rate firms");
    },
  },
  mounted() {
    this.form = {
      councilId: this.firmAssociation.code,
    };
    this.firmHasPortal();
    this.getReverseAssociation();
  },
  watch: {
    firmAssociation() {
      this.form = {
        councilId: this.firmAssociation.code,
      };
      this.firmHasPortal();
      this.getReverseAssociation();
    },
  },
  methods: {
    firmHasPortal() {
      FirmService.show(this.firm.id, {
        includes: "portal",
      }).then((response) => {
        let organization = JsonDenormalizer.denormalize(response);
        this.portal = organization.portal || null;
      });
    },
    async getReverseAssociation() {
      // This is for the tag input
      // Need to attach tags to firm_firm->parent = selected_firm AND firm_firm->child = auth_user->firm
      this.reverseAssociation = null;

      const data = await FirmService.firmAssociations({
        parent_id: this.firm.id,
        child_id: this.user.firmId,
        includes: "tags",
      }).then((response) => JsonDenormalizer.denormalize(response));

      if (data.length) {
        this.reverseAssociation = data[0];
      }
    },
    async rate(data) {
      await FirmService.rate(this.firm.id, data).then((response) => {
        // this.$emit('updateOrganization', JsonDenormalizer.denormalize(response))
        // this.modal.active = false;
      });
    },
    transformedData() {
      let formData = new FormData(this.$refs.form);

      formData.append("file", this.logo);

      formData.append("firm_firm_id", this.firmAssociation.id);

      formData.append("firm_id", this.firm.id);

      formData.append("code", this.form.councilId);

      if (this.currentTags) {
        formData.append("tags", this.currentTags.toString());
      }

      let active_tags = [];

      Object.entries(this.activeTags).forEach(([key, value]) => {
        active_tags.push(value);
      });

      if (active_tags.length) {
        formData.append("active_tags", active_tags.toString());
      }

      return formData;
    },
    saveLogo() {
      FirmService.updateLogo(this.transformedData()).then((response) => {
        let firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "Successfully updated.",
          type: "is-info",
          position: "is-top-right",
        });

        this.$emit("updateLogo", response);

        this.logo = null;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationBrand.vue